















import {Component} from "vue-property-decorator";
import CommonBase from "@/components/CommonBase";

@Component
export default class RegcodeInfoText extends CommonBase {
}
